<template>
  <div class="add-all-button">
    <app-button outlined :aria-label="'Add All'" :is-disabled="isDisabled" @click="handleClick">
      <div class="add-all-button__slot">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
          <g transform="translate(-1413.000000, -166.000000) translate(1403.000000, 159.000000)">
            <path
              fill="currentColor"
              stroke="currentColor"
              stroke-width=".5"
              d="M10.306 2.881c.342-.341.896-.341 1.237 0 .342.342.342.896 0 1.238L8.45 7.212l3.094 3.094c.342.342.342.896 0 1.237-.341.342-.895.342-1.237 0L7.212 8.45l-3.093 3.094c-.314.314-.805.34-1.148.079l-.09-.079c-.341-.341-.341-.895 0-1.237l3.093-3.094-3.093-3.093c-.341-.342-.341-.896 0-1.238.342-.341.896-.341 1.238 0l3.093 3.093z"
              transform="translate(10.000000, 7.000000) translate(7.212311, 7.212311) scale(-1, 1) rotate(-315.000000) translate(-7.212311, -7.212311)"
            />
          </g>
        </svg>
        <span class="add-all-button__text">Add All</span>
      </div>
    </app-button>
  </div>
</template>

<script>
export default {
  name: "AddAllButton",
  props: {
    isDisabled: Boolean
  },
  methods: {
    handleClick(e) {
      e.stopImmediatePropagation();
      return this.$emit("click", e);
    }
  }
};
</script>

<style lang="scss">
.add-all-button {
  width: 86px;
  height: 28px;
  &__slot {
    display: flex;
    align-items: center;
  }
  &__text {
    width: 51px;
    height: 17px;
    font-size: 14px;
    font-family: Lato;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .btn {
    border: none;
    height: 100%;
    border-radius: 14px;
    color: $group-3-color-4;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);

    &__overlay--outlined {
      border: none;
    }

    svg {
      margin-right: 4px;
    }

    &:active:enabled {
      &__overlay--outlined {
        background-color: black;
        opacity: 0.1;
      }
      box-shadow: none;
    }

    &:disabled {
      opacity: 1;
      color: $group-3-color-2;

      .add-all-button__slot {
        opacity: 0.2;
      }

      .btn__overlay--outlined {
        background-color: $group-2-color-2;
        opacity: 0.08;
      }
      box-shadow: none;
    }
  }
}
</style>
